<div class="notification-list">
  <ng-container *ngIf="notificaciones.length > 0; else noNotificaciones">
    <div class="notification-item" *ngFor="let notificacion of notificaciones; index as i">
      <p-card [header]="notificacion.title" [subheader]="notificacion.date | date: 'dd/MM/yy, HH:mm'"
        styleClass="p-card-shadow w-full compact-notification-card">
        <div class="flex flex-wrap align-items-start">
          <span class="mr-2">
            <i class="pi pi-bell text-4xl"></i>
          </span>
          <p class="m-0">{{ notificacion.body }}</p>
        </div>
        <ng-template pTemplate="footer">
          <div class="flex justify-content-end w-full">
            <p-button label="Borrar" icon="pi pi-trash" (click)="removeNotification(i,notificacion)"></p-button>
          </div>

        </ng-template>
      </p-card>


    </div>
  </ng-container>
  <ng-template #noNotificaciones>
    <div class="flex flex-wrap justify-content-center">
      <p-message severity="info" text="No hay notificaciones disponibles" styleClass="mr-2"></p-message>
    </div>
  </ng-template>
</div>